import React from "react";

import { Grid } from "@mui/material";

import AdPlacement from "./AdPlacement";

/**
 * Legacy wrapper kept so existing imports keep working.
 * Prefer <AdPlacement placement="..." /> directly.
 */
const TeflBanner = ({ placement = "jobs" }) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ margin: "1rem auto", width: "100%", minWidth: 0, maxWidth: "100%" }}
    >
      <AdPlacement placement={placement} />
    </Grid>
  );
};

export default TeflBanner;
